/*
  Dabi Deri — imleci takip eden yön oku.

  Referans sitedeki davranış: büyük görselin üzerinde imleç bir ok oluyor;
  sağ yarıda sonraki, sol yarıda önceki görsele geçiriyor. Hızlı inceleme
  penceresinde bu zaten vardı; aynı davranış artık ürün sayfasının
  galerisinde de var ve tek yerden geliyor.

  `window.DabiCursorNav.attach(stage, api)` ile başka bileşenler de
  kullanabilir. `api`: { count(), index(), go(i) }.

  Yalnızca fare/kalem olan aygıtlarda kurulur; dokunmatikte küçük görseller
  ve kaydırma zaten var.
*/

(() => {
  const OK_ISARETI =
    '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M5 12h13M14 7l5 5-5 5"/></svg>';

  const destekVar = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const attach = (stage, api) => {
    if (!stage || !api || stage.dataset.dabiCnav === 'on') return;
    if (api.count() < 2) return;

    stage.dataset.dabiCnav = 'on';
    stage.classList.add('dabi-cnav-host');

    const cursor = document.createElement('span');
    cursor.className = 'dabi-cnav';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = OK_ISARETI;
    stage.appendChild(cursor);

    const yerlestir = (event) => {
      const box = stage.getBoundingClientRect();
      const x = event.clientX - box.left;
      cursor.style.left = `${x}px`;
      cursor.style.top = `${event.clientY - box.top}px`;
      cursor.dataset.direction = x < box.width / 2 ? 'prev' : 'next';
      cursor.classList.add('is-visible');
    };

    stage.addEventListener('pointerenter', yerlestir);
    stage.addEventListener('pointermove', yerlestir);
    stage.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));

    stage.addEventListener(
      'click',
      (event) => {
        // Görselin üzerindeki gerçek bağlantı/düğmeler kendi işini yapsın.
        if (event.target.closest('a, button, [role="button"]') && !event.target.closest('.dabi-cnav')) {
          return;
        }
        const box = stage.getBoundingClientRect();
        const ileri = event.clientX - box.left >= box.width / 2;
        const toplam = api.count();
        const simdi = Math.max(0, api.index());
        event.preventDefault();
        api.go((simdi + (ileri ? 1 : -1) + toplam) % toplam);
      },
      true
    );
  };

  window.DabiCursorNav = { attach };

  /* ---------- ürün sayfası galerisi: büyüteç + kenar okları ----------
     Craft görselin tamamını "büyüt" düğmesiyle kaplıyor; eski ok o yüzden
     tıklamayı hiç alamıyordu. Şimdi görsel üç bölge:
       - sol / sağ kenar: imleç ok olur, tıklama önceki / sonraki görsele geçer
       - orta: imleç yuvarlak bir büyüteç olur, deri dokusu ve dikişler
         büyütülmüş görünür; tıklama Craft'ın tam ekran görünümünü açar
     Ayarlar Tema ayarları > Dabi bileşenleri'nden (DabiGalleryConfig). */

  const readConfig = () => {
    const el = document.getElementById('DabiGalleryConfig');
    try {
      return el ? JSON.parse(el.textContent) : {};
    } catch (err) {
      return {};
    }
  };

  // En büyük srcset kaynağı: büyüteçte bulanıklık olmasın.
  const largestSource = (img) => {
    if (img.dataset.dabiZoomSrc) return img.dataset.dabiZoomSrc;
    let best = img.currentSrc || img.src;
    let bestW = 0;
    (img.getAttribute('srcset') || '').split(',').forEach((part) => {
      const [url, w] = part.trim().split(/\s+/);
      const n = parseInt(w, 10);
      if (url && n > bestW) {
        bestW = n;
        best = url;
      }
    });
    img.dataset.dabiZoomSrc = best;
    return best;
  };

  // object-fit: contain ile görselin kutu içindeki gerçek alanı.
  const drawnBox = (img) => {
    const box = img.getBoundingClientRect();
    const nw = img.naturalWidth || box.width;
    const nh = img.naturalHeight || box.height;
    const scale = Math.min(box.width / nw, box.height / nh);
    const w = nw * scale;
    const h = nh * scale;
    return { left: box.left + (box.width - w) / 2, top: box.top + (box.height - h) / 2, width: w, height: h };
  };

  const galeriKur = () => {
    const cfg = readConfig();
    const loupeOn = cfg.loupe !== false;
    const size = Number(cfg.size) || 200;
    const zoom = (Number(cfg.zoom) || 250) / 100;
    const edge = (Number(cfg.edge) || 18) / 100;

    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const stage = gallery.querySelector('.product__media-list');
      if (!stage || stage.dataset.dabiCnav === 'on') return;
      const thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
      const canNav = thumbs.length > 1;
      if (!canNav && !loupeOn) return;

      stage.dataset.dabiCnav = 'on';
      stage.classList.add('dabi-cnav-host');
      stage.style.setProperty('--dabi-loupe-size', `${size}px`);

      const arrow = document.createElement('span');
      arrow.className = 'dabi-cnav';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = OK_ISARETI;
      stage.appendChild(arrow);

      const lens = document.createElement('span');
      lens.className = 'dabi-loupe';
      lens.setAttribute('aria-hidden', 'true');
      stage.appendChild(lens);

      let hint = null;
      if (loupeOn && cfg.hint) {
        hint = document.createElement('span');
        hint.className = 'dabi-loupe-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = cfg.hint;
        stage.appendChild(hint);
      }

      let mode = '';
      const activeIndex = () => thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      const go = (dir) => {
        const n = thumbs.length;
        const i = (Math.max(0, activeIndex()) + dir + n) % n;
        thumbs[i].click();
      };

      const hideAll = () => {
        mode = '';
        arrow.classList.remove('is-visible');
        lens.classList.remove('is-visible');
        stage.classList.remove('is-inspecting');
      };

      const onMove = (event) => {
        const item = event.target.closest('.product__media-item');
        const img = item && item.querySelector('.product__media img');
        if (!img) return hideAll();

        const stageBox = stage.getBoundingClientRect();
        const box = drawnBox(img);
        const x = event.clientX - box.left;
        const y = event.clientY - box.top;
        const rx = x / box.width;
        const inside = x >= 0 && y >= 0 && x <= box.width && y <= box.height;
        const px = event.clientX - stageBox.left;
        const py = event.clientY - stageBox.top;

        // Ok yalnizca kenarlarin orta yuksekliginde; koseler ve buyut simgesi
        // disarida kaliyor ki orada da buyutec calissin (simge sag altta
        // oldugu icin eskiden ustune gelince ok cikiyordu).
        const ry = y / box.height;
        const icon = item.querySelector('.product__media-icon');
        const ib = icon ? icon.getBoundingClientRect() : null;
        const onIcon = ib && event.clientX >= ib.left - 12 && event.clientX <= ib.right + 12 && event.clientY >= ib.top - 12 && event.clientY <= ib.bottom + 12;
        const edgeBand = ry > 0.18 && ry < 0.82;

        if (canNav && edgeBand && !onIcon && (rx < edge || rx > 1 - edge)) {
          mode = rx < edge ? 'prev' : 'next';
          arrow.dataset.direction = mode;
          arrow.style.left = `${px}px`;
          arrow.style.top = `${py}px`;
          arrow.classList.add('is-visible');
          lens.classList.remove('is-visible');
          stage.classList.remove('is-inspecting');
          return;
        }

        arrow.classList.remove('is-visible');
        if (!loupeOn || !inside) {
          mode = '';
          lens.classList.remove('is-visible');
          stage.classList.remove('is-inspecting');
          return;
        }

        mode = 'zoom';
        const src = largestSource(img);
        if (lens.dataset.src !== src) {
          lens.style.backgroundImage = `url("${src}")`;
          lens.dataset.src = src;
        }
        const bw = box.width * zoom;
        const bh = box.height * zoom;
        lens.style.backgroundSize = `${bw}px ${bh}px`;
        lens.style.backgroundPosition = `${size / 2 - x * zoom}px ${size / 2 - y * zoom}px`;
        lens.style.left = `${px}px`;
        lens.style.top = `${py}px`;
        lens.classList.add('is-visible');
        stage.classList.add('is-inspecting');
        if (hint) hint.classList.add('is-seen');
      };

      // Her harekette olcum yerine karede bir: olcumler tek rAF icinde toplanir.
      let pendingMove = null;
      const queueMove = (event) => {
        if (pendingMove === null) {
          window.requestAnimationFrame(() => {
            const e = pendingMove;
            pendingMove = null;
            if (e) onMove(e);
          });
        }
        pendingMove = event;
      };
      stage.addEventListener('pointermove', queueMove);
      stage.addEventListener('pointerenter', onMove);
      stage.addEventListener('pointerleave', hideAll);

      // Kenarda tıklama: Craft'ın büyüt düğmesine ulaşmadan yakalanıyor.
      stage.addEventListener(
        'click',
        (event) => {
          if (mode !== 'prev' && mode !== 'next') return;
          event.preventDefault();
          event.stopPropagation();
          go(mode === 'prev' ? -1 : 1);
        },
        true
      );
    });
  };

  const baslat = () => {
    if (!destekVar()) return;
    galeriKur();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  // Varyant değişince Craft ürün bilgisini yeniden basıyor; galeri de yenilenir.
  document.addEventListener('shopify:section:load', baslat);
})();
